import { setECommerceProductAction as setECommerceProductOperation } from 'editor/src/store/variants/slice';

export default setECommerceProductOperation;
